
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.437 13.137a.9.9 0 011.272 0l4.092 4.092 4.092-4.092a.9.9 0 011.272 1.272L16.8 19.773l-5.364-5.364a.9.9 0 010-1.272z","fill":"currentColor"}})])
          )
        }
      }
    